import { navigateOutline } from 'ionicons/icons';
import { ReactElement } from 'react';
import { getLocalizedText } from '../../../../../../i18n/i18n.utils';
import { useFlowServices } from '../../../hook/flow-service.hooks';
import {
  MoveToPointProps,
  useMoveToPoint,
} from '../../../hook/move-to-point.hooks';
import { FlowItem } from '../../../model/flow.types';
import {
  FlowItemBaseAction,
  FlowItemBaseActionCommonProps,
} from './flow-item-base-action';

interface FlowItemMoveHereActionProps extends FlowItemBaseActionCommonProps {
  item?: FlowItem;
}

const FlowItemMoveHereAction = (
  props: FlowItemMoveHereActionProps
): ReactElement => {
  const { item, disabled } = props;

  const { flow, flowItemService } = useFlowServices();

  const moveToPointProps: MoveToPointProps =
    flowItemService.getMoveToPointProps(flow, item);

  const { isLoading, startMoveToPoint } = useMoveToPoint();

  return (
    <FlowItemBaseAction
      icon={navigateOutline}
      label={getLocalizedText('common:move_here')}
      disabled={isLoading || disabled}
      onClick={() => {
        startMoveToPoint(moveToPointProps);
      }}
    />
  );
};

export { FlowItemMoveHereAction };
